module.exports = __webpack_public_path__ + "media/images/icon-trash-9a673d1fb781b1884ee941830af7857d.svg";